// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__22j9V","itemTitle":"ClientEmergencyInfo_itemTitle__3uoT0","itemText":"ClientEmergencyInfo_itemText__2KoR5"};